<template>
  <g>
    <path
      d="M22 4.95024C21.79 4.78024 19.67 3.00024 16.5 3.00024C13.32 3.00024 11.21 4.78024 11 4.95024L16.5 12.0002L22 4.95024Z"
    />
    <path
      d="M19.2 15.2803L16.66 14.9903C16.05 14.9203 15.45 15.1303 15.02 15.5603L13.18 17.4003C10.35 15.9603 8.03001 13.6503 6.59001 10.8103L8.44001 8.96027C8.87001 8.53027 9.08001 7.92027 9.01001 7.32027L8.72001 4.80027C8.60001 3.79027 7.75001 3.03027 6.73001 3.03027H5.00001C3.87001 3.03027 2.93001 3.97027 3.00001 5.10027C3.53001 13.6403 10.36 20.4703 18.9 21.0003C20.03 21.0703 20.97 20.1303 20.97 19.0003V17.2703C20.97 16.2503 20.21 15.4003 19.2 15.2803Z"
    />
  </g>
</template>
